import { TFunction } from 'i18next'
import { z } from 'zod'

import { baseContentSchema } from '../shared/schemas'
import { BlockConfig } from '../shared/types'

const affiliateContentSchema = baseContentSchema.merge(
  z.object({
    websiteUrl: z.string().optional(),
    title: z.string().optional(),
    description: z.string().optional(),
    buttonText: z.string().optional(),
  }),
)

export type AffiliateContentSchema = z.infer<typeof affiliateContentSchema>

export const affiliateConfig = ({
  t,
}: {
  t: TFunction<'translation', undefined>
}): BlockConfig => ({
  kind: 'AFFILIATE',
  minW: 2,
  minH: 3,
  maxW: 4,
  maxH: 24,
  contentKey: 'affiliateContent',
  schema: affiliateContentSchema,
  name: t('fingertip_affiliate_'),
  description: t('give_20_off_get_up_t'),
  searchTags: ['cello', 'discount', 'affiliate', 'refer'],
})
